(function () {
  function initProductImageFiltering() {
    var dataElement = document.getElementById('product-image-data');
    if (!dataElement) return;

    var images = [];
    var section = null;

    try {
      images = JSON.parse(dataElement.getAttribute('data-images') || '[]');
      section = document.getElementById(dataElement.getAttribute('data-section-id'));
    } catch (error) {
      return;
    }

    if (!section || !Array.isArray(images)) return;

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !variant.options) return;

      var selectedOptions = variant.options.map(function (option) {
        return String(option).toLowerCase();
      });

      var thumbnailList = section.querySelector('product-media .product__thumbnail-list-inner');
      var dotsNav = section.querySelector('product-media .dots-nav');

      images.forEach(function (imageRule, index) {
        if (imageRule === 'all') return;

        var shouldShow = true;

        String(imageRule).split('_').forEach(function (ruleOption, optionIndex) {
          if (ruleOption !== 'all' && String(ruleOption).toLowerCase() !== selectedOptions[optionIndex]) {
            shouldShow = false;
          }
        });

        var mediaItem = section.querySelector('[data-original-position="' + index + '"]');
        var thumbnailItem = thumbnailList && thumbnailList.children ? thumbnailList.children[index] : null;
        var dotItem = dotsNav && dotsNav.children ? dotsNav.children[index] : null;
        var items = [mediaItem, thumbnailItem, dotItem];

        items.forEach(function (item) {
          if (!item) return;
          if (shouldShow) {
            item.classList.remove('is-filtered');
          } else {
            item.classList.add('is-filtered');
          }
        });
      });
    });
  }

  function initMobileSearchBar() {
    var input = document.querySelector('.mobile-searchbar .predictive-search__input');
    if (!input) return;

    var closeButton = document.querySelector('.mobile-searchbar .searchbar-close');
    var searchIcon = document.querySelector('.mobile-searchbar .icon--header-search');
    var results = document.querySelector('.mobile-searchbar .predictive-search__results');
    var footer = document.querySelector('.mobile-searchbar .drawer__footer');

    if (!closeButton || !searchIcon) return;

    document.body.style.overflow = 'auto';
    var isOpen = false;

    input.addEventListener('keydown', function (event) {
      window.setTimeout(function () {
        if (!isOpen) {
          closeButton.style.display = 'block';
          searchIcon.style.display = 'none';
          document.body.style.overflow = 'hidden';
          isOpen = true;
        }

        if ((event.keyCode === 8 && input.value === '') || (input.value === ' ' && event.keyCode !== 13)) {
          document.body.style.overflow = 'auto';
          closeButton.style.display = 'none';
          searchIcon.style.display = 'block';
          isOpen = false;
        }
      }, 1);
    });

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (event.detail === 0) return;

      document.body.style.overflow = 'auto';
      isOpen = false;
      input.value = '';
      closeButton.style.display = 'none';
      searchIcon.style.display = 'block';

      if (results) results.setAttribute('hidden', '');
      if (footer) footer.setAttribute('hidden', '');
    });
  }

  function initCountdownTimer() {
    var section = document.querySelector('.shopify-section--countdown-condensed');
    var timer = document.querySelector('.countdown-condensed__timer');
    if (!section || !timer) return;

    function updateTopOffset() {
      var header = document.querySelector('.shopify-section--header');
      if (header) section.style.top = header.offsetHeight + 'px';
    }

    updateTopOffset();
    window.addEventListener('resize', updateTopOffset);

    var expiresAt = timer.getAttribute('expires-at');
    if (!expiresAt) return;

    var daysElement = document.querySelector('[type="days"]');
    var hoursElement = document.querySelector('[type="hours"]');
    var minutesElement = document.querySelector('[type="minutes"]');
    var secondsElement = document.querySelector('[type="seconds"]');
    if (!daysElement || !hoursElement || !minutesElement || !secondsElement) return;

    var expiresAtTimestamp = new Date(expiresAt).getTime();
    if (isNaN(expiresAtTimestamp)) return;

    var isHidden = timer.getAttribute('data-show') === 'false';

    function hideCountdown() {
      section.style.maxHeight = '0px';
      isHidden = true;
    }

    function updateCountdown() {
      var timeLeft = expiresAtTimestamp - Date.now();

      if (timeLeft <= 0) {
        hideCountdown();
        timeLeft = 0;
      }

      var days = Math.floor(timeLeft / 86400000);
      var hours = Math.floor((timeLeft % 86400000) / 3600000);
      var minutes = Math.floor((timeLeft % 3600000) / 60000);
      var seconds = Math.floor((timeLeft % 60000) / 1000);

      daysElement.textContent = days;
      hoursElement.textContent = hours;
      minutesElement.textContent = minutes;
      secondsElement.textContent = seconds;

      if (!isHidden) section.style.maxHeight = '500px';
    }

    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductImageFiltering();
    initMobileSearchBar();
    initCountdownTimer();
  });
})();
